'use strict';

/**
 *
 * @name: apiCategoryService
 *
 */

function ApiCategoryService(
  $rootScope,
  APP_CONSTANTS,
  $http
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function getCategory() {
    var target = $rootScope.apiUrlNew + '/category';
    return $http.get(target);
  }

  function getCategoryById(id) {

    var target = $rootScope.apiUrlNew + '/category/' + id;

    return $http.get(target);
  }

  function getCategoryBySlug(slug) {

    var target = slug => $rootScope.apiUrlNew + '/category/getbyslug/' + slug;

    const redirects = {
      music: 'music-and-dance',
      culture: 'culture-and-lifestyles'
    }

    return $http.get(target(slug)).catch((err) => {
      if (redirects[slug]) {
        return $http.get(target(redirects[slug]))
      }
      return Promise.reject(err);
    })
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    getCategory: getCategory,
    getCategoryById: getCategoryById,
    getCategoryBySlug: getCategoryBySlug,
  };
}

export default ApiCategoryService;



// WEBPACK FOOTER //
// ./app/components/_api/category.service.js